module.exports = __webpack_public_path__ + "static/media/6.780bb91f.svg";